import { netsparkAxios } from 'core/services/HTTPService';
import { IEngagementsOrdersByPeriodItem } from 'pages/Dashboard/Dashboard.models';
import { getEngagementsOrdersMrcTechnicalOverlayUrl } from 'pages/Dashboard/api/apiUrls';
// eslint-disable-next-line no-unused-vars
import { TPeriod } from 'shared/CustomRangePicker/CustomRangePicker.models';

export const getEngagementsOrdersTOMrc = (
  signal: AbortSignal, params: TPeriod) => netsparkAxios
  .get<IEngagementsOrdersByPeriodItem[]>(
    getEngagementsOrdersMrcTechnicalOverlayUrl,
    { signal, params },
  );
